import apiClient from './api';
import { ApiResponse } from '@/types';

export interface UserWithStats {
  id: string;
  username: string;
  email: string;
  role: 'admin' | 'user' | 'guest';
  status: 'active' | 'inactive' | 'banned';
  created_at: number;
  updated_at: number;
  last_login_at?: number;
  api_quota: number;
  api_used: number;
  usage_percent: number;
  remaining: number;
}

export interface SystemStats {
  total_users: number;
  total_operations: number;
  total_quota: number;
  total_used: number;
  avg_usage_percent: number;
  top_operations: { operation: string; count: number }[];
}

export const adminAPI = {
  // 获取所有用户列表
  getUsers: (): Promise<ApiResponse<UserWithStats[]>> => 
    apiClient.get('/admin/users'),

  // 修改用户配额
  updateUserQuota: (userId: string, updates: { api_quota?: number; api_used?: number }): Promise<ApiResponse> =>
    apiClient.put(`/admin/users/${userId}/quota`, updates),

  // 删除用户
  deleteUser: (userId: string): Promise<ApiResponse> =>
    apiClient.delete(`/admin/users/${userId}`),

  // 获取系统统计
  getSystemStats: (): Promise<ApiResponse<SystemStats>> =>
    apiClient.get('/admin/stats'),
};
